import React from "react";
import useOpenDocument from "../../../hooks/useOpenDocument";
import { TableLoadingRow } from "../../../components/tables/VirtualTable";
import { useOpenProject } from "../hooks/useOpenProject";
import { useClientDocuments } from "../../../hooks/ClientDocumentsContext";
import { DocumentType } from "../../../types/DocumentType";
import { ThemedSpan } from "../../../components/utilities";
import { ClientDocumentsTableRowActionColumn } from "./ClientDocumentsTableRowActionColumn";
import { ClientDocumentsTableRowColumn } from "./ClientDocumentsTableRowColumn";
import { ClientDocumentsTableRowDateColumn } from "./ClientDocumentsTableRowDateColumn";
import { ClientDocumentsTableRowStatusColumn } from "./ClientDocumentsTableRowStatusColumn";
import { ClientDocumentsTableRowTypeColumn } from "./ClientDocumentsTableRowTypeColumn";

const ClientDocumentsTableRow = ({ 
    data, 
    index, 
    style 
} : Readonly<{
    data: DocumentType[],
    index: number,
    style: any
}>) => {
    const { height } = style;
    const { openProject } = useOpenProject();
    const { openDocument, isLoading: isOpeningDocument } = useOpenDocument();
    const { isFetching } = useClientDocuments()!;
    const isLoading = index >= data.length || isFetching;

    const handleOpenDocument = (e: any, documentId: string, fileName: string) : void => {
        if (e && typeof (e.preventDefault) === 'function') {
            e.preventDefault();
        }
        if (isOpeningDocument) {
            return;
        }
        openDocument(documentId, fileName);
    };

    const handleOpenProject = (e: any, projectId: string) : void => {
        if (e && typeof (e.preventDefault) === 'function') {
            e.preventDefault();
        }
        openProject(projectId);
    };

    // do not return a data row when the data has not yet been collected from the backend
    if (isLoading === true) {
        return <TableLoadingRow style={{ height }} />
    }

    // NOTE: moved this due to accessing a null/loading row causing a react crash/error
    const {
        documentId,
        functionDescription,
        fileName,
        documentDescription,
        projectDescription,
        projectId
    } = data[index];

    return (
        <tr style={{ height }}>
            <ClientDocumentsTableRowTypeColumn data={data[index]} width="2.5%" />
            <ClientDocumentsTableRowColumn className="text-truncate" width="25%">
                <p className="m-0 lh-1">
                    <a href={`open?id=${documentId}`} onClick={(e) => handleOpenDocument(e, documentId, fileName)}>{fileName}</a>
                    <br/>
                    <ThemedSpan variant="muted" className="fs-smallest">{functionDescription}</ThemedSpan>
                </p>
            </ClientDocumentsTableRowColumn>
            <ClientDocumentsTableRowColumn className="text-truncate" width="22%">
                <span>{documentDescription}</span>
            </ClientDocumentsTableRowColumn>
            <ClientDocumentsTableRowColumn className="text-truncate" width="13.5%">
                {projectId 
                    ? (<a href={`../projects?projectId=${projectId}`} onClick={(e) => handleOpenProject(e, projectId)}>{projectDescription}</a>)
                    : (<span>-</span>)
                }
            </ClientDocumentsTableRowColumn>
            <ClientDocumentsTableRowStatusColumn data={data[index]} width="2.5%" />
            <ClientDocumentsTableRowDateColumn data={data[index]} width="7.5%" />
            <ClientDocumentsTableRowActionColumn data={data[index]} width={2.5} />
        </tr>
    );
};

export default ClientDocumentsTableRow;